import Email from '../../component/inputs/email/index'
import Password from '../../component/inputs/password/index'
import PasswordCheck from '../../component/inputs/passwordCheck/index'
import FirstName from '../../component/inputs/firstName/index'
import LastName from '../../component/inputs/lastName/index'
import Nif from '../../component/inputs/nif/index'
import Phone from '../../component/inputs/phone/index'
import FacebookButton from '../../component/buttons/facebook/index'
import GoogleButton from '../../component/buttons/google/index'
import Button from '../../component/buttons/button/index'
import FacebookSimple from '../../component/buttons/facebookSimple/index'
import GoogleSimple from '../../component/buttons/googleSimple/index'
import Close from '../../component/close/index'
import axios from 'axios'
import ErrorBlock from '../../component/error/index'


export default {
  name: 'Sign-up',
  inject: ['$validator'],
  data () {
    return {
      form: {
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        nif: '',
        phone_number: ''
      },
      isLoading: false,
      isCustomer: false
    }
  },
  components: {
    'kw-email': Email,
    'kw-password': Password,
    'kw-password-check': PasswordCheck,
    'kw-phone': Phone,
    'kw-facebook': FacebookButton,
    'kw-google': GoogleButton,
    'kw-first-name': FirstName,
    'kw-last-name': LastName,
    'kw-nif': Nif,
    'kw-button': Button,
    'kw-error': ErrorBlock,
    'kw-facebook-simple': FacebookSimple,
    'kw-google-simple': GoogleSimple,
    'kw-close' : Close
  },
  computed: {
    showErrorPage () {
      return this.$route.meta.hasOwnProperty('errorCode')
    },
    errorCode () {
      return !this.showErrorPage ? null : this.$route.meta.errorCode
    },
    customerReference () {
      return !this.showErrorPage ? null : this.$route.query.customer
    },
    isFormValid () {
      if (
        this.errors.items.length !== 0 ||
        this.form.email === '' ||
        this.form.password === '' ||
        this.form.nif === '' ||
        this.form.first_name === '' ||
        this.form.last_name === '' ||
        this.form.phone_number === ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    if (this.$route.meta.customer === undefined) {
      return
    }

    if (!this.$route.meta.customer.data.valid) {
      /// // Error
      return
    }

    let user = this.$route.meta.customer.data.customer

    this.form.email = user.email
    this.form.first_name = user.firstName
    this.form.last_name = user.lastName
    this.form.nif=user.nif
    this.isCustomer = true
  },
  methods: {
    handleAuth (user) {
      this.form.email = user.email
      this.form.first_name = user.first_name
      this.form.last_name = user.last_name
      this.form.nif = user.nif
    },
    registerHandler () {
      if (this.isCustomer) {
        let data = {
          email: this.form.email,
          password: this.form.password,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          customer: this.$route.query.customer,
          phone_number: this.form.phone_number,
          nif: this.form.nif
        }

        this.validateAndSubmit(data)
      } else {
        this.validateAndSubmit(this.form)
      }
    },

    validateAndSubmit (data) {
      this.isLoading = true

      axios({
        method: 'POST',
        url: `${process.env.API_URL}/user/register`,
        data: data,
        withCredentials: 'true',
        credentials: 'same-origin'
      }).then(response => {
        if (response.data.valid) {
          this.isLoading = true

          if (this.isCustomer) {
            this.$router.push({ name: 'Login' })
          } else {
            this.$router.push({ name: 'AccountCreated' })
          }
        } else {
          this.isLoading = true

              // response.body.forEach(error => {
              //   console.log(error.path[0]);

              //   this.errors.add('email')
              // });
        }
      }).catch(error => {
        this.isLoading = true
        console.log(error)
      })
    },

    validateForm () {
      this.$validator.validateAll().then(result => {

      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/views/signUp/signUp.js